import { DataProvider } from "./ContextServer/DataContext";
import { DeclareProvider } from "./ContextServer/DeclareContext";
import "./App.css";

import Header from "./components/Header";
import Declare from "./pages/Menu/Declare/User/Declare";
// import Notice from "./pages/Menu/Notice/Notice";
// import NoticeDetail from "./pages/Menu/Notice/NoticeDetail";
import Main from "./pages/Monitoring/Main";
import DeclareList from "./pages/Menu/Declare/User/DeclareList";
import Forecast from "./pages/Menu/Forecast";
// import Info from "./pages/Menu/Info/Info";
import "./scss/style.scss";
import { Route, Routes } from "react-router-dom";
import DeclareAnswer from "./pages/Menu/Declare/User/Answer/DeclareAnswer";
import { LoginProvider } from "./ContextServer/LoginConetxt";
import AdminLogins from "./pages/Menu/Declare/Admin/AdminLogin/AdminLogins";
import AdminDeclareList from "./pages/Menu/Declare/Admin/AdminDeclareList";
const enShowAir = {
  ShowAir: 0,
  ShowStink: 1,
  ShowMinwon: 2,
};

function App() {
  // 빌드시 콘솔 삭제
  if (process.env.NODE_ENV === "production") {
    console = window.console || {};
    console.log = function no_console() {};
    console.warn = function no_console() {};
    console.error = function () {};
  }
  return (
    <>
      <LoginProvider>
        <DataProvider>
          <DeclareProvider>
            <div>
              <Header />
              <Routes>
                <Route path="/odor" element={<Main enShowAir={enShowAir} />} />
                <Route path="/forecast/" element={<Forecast />} />
                <Route path="/odor/declare/" element={<Declare />} />
                <Route path="/odor/login" element={<AdminLogins />} />
                <Route path="/odor/declarelist/" element={<DeclareList />} />
                <Route
                  path="/odor/declarelist/admin"
                  element={<AdminDeclareList />}
                />

                <Route
                  path="/odor/declarelist/answer"
                  element={<DeclareAnswer />}
                />
              </Routes>
            </div>
          </DeclareProvider>
        </DataProvider>
      </LoginProvider>
    </>
  );
}

export default App;
